import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { fetchOptions } from '../../services/masters/optionService';
import { ACTIONS } from '../../constants/apiEndpoints';

export const getOptions = createAsyncThunk(
  ACTIONS.option_values,
  async (listOfOptions, thunkAPI) => {
    try {
      const response = await fetchOptions(listOfOptions);
      if (response.data.statuscode !== 200) {
        return thunkAPI.rejectWithValue({
          message: `Failed to load options: ${response.data.message}`,
          statuscode: response.data.statuscode,
        });
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error.response?.data?.message,
        statuscode: error.response?.status || 500
      });
    }
  }
);

const optionSlice = createSlice({
  name: 'option',
  initialState: {
    statuscode: 0,
    message: null,
    description: null,
    data: {},
    loading: false,
    error: null,
  },
  reducers: {
    mergeOptions: (state, action) => {
      const incomingList = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      
      for (const incoming of incomingList) {
        const existing = state.data.DEPOSIT_ACCOUNTS.find(
          d => d.optionName === incoming.optionName
        );
        if (existing) {
          const existingOptions = new Set(existing.values.map(v => v.optionName));
          const newValues = incoming.values.filter(v => !existingOptions.has(v.optionName));
          existing.values.push(...newValues);
        } else {
          state.data.DEPOSIT_ACCOUNTS.push(incoming);
        }
      }
    },    
  },
  extraReducers: builder => {
    builder
      .addCase(getOptions.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOptions.fulfilled, (state, action) => {
        state.loading = false;
        const { statuscode, message, description, data } = action.payload;
        state.statuscode = statuscode;
        state.message = message;
        state.description = description;

        const key = action.meta.arg[0];
        if (key) {
          state.data[key] = [...(state.data[key] || []), ...data];
        }
        
      })
      .addCase(getOptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { mergeOptions } = optionSlice.actions;
export default optionSlice.reducer;
